<template>
	<GridForm
		:id="id"
		:form-id="data.formId"
		:settings="data.settings"
		:submit-button-data="data.submitButtonData"
		:styles="computedStyles"
		:show-success-message="showSuccessMessage"
		:is-error="isError"
		:is-user-site="$options.IS_USER_SITE"
		:theme="data.settings.theme"
		@on-submit="onSubmit"
	>
		<PostSubmitElement
			:show-success-message="showSuccessMessage"
			:success-message="data.settings.successMessage"
			:is-loading="isLoading"
			:is-error="isError"
			:theme="data.settings.theme"
		/>
	</GridForm>
</template>

<script>
import { mapState } from 'vuex';
import { defineComponent } from 'vue';

import GridForm from '@zyro-inc/site-modules/components/elements/form/GridForm.vue';
import PostSubmitElement from '@zyro-inc/site-modules/components/elements/form/PostSubmitElement.vue';
import {
	MINIMUM_LOAD_TIME,
	SUBMIT_ACTIONS,
} from '@zyro-inc/site-modules/components/elements/form/constants';
import { useGridForm } from '@zyro-inc/site-modules/components/elements/form/useGridForm';
import { getPagePathFromId } from '@zyro-inc/site-modules/utils/page/getPagePathFromId';

const IS_USER_SITE = true;

export default defineComponent({
	IS_USER_SITE,

	components: {
		GridForm,
		PostSubmitElement,
	},

	props: {
		id: {
			type: String,
			required: true,
		},
		data: {
			type: Object,
			required: true,
		},
	},

	setup(props) {
		const { computedStyles } = useGridForm(props);

		return {
			computedStyles,
		};
	},

	data() {
		return {
			isLoading: false,
			showSuccessMessage: false,
			isError: false,
		};
	},

	computed: {
		...mapState([
			'website',
			'currentLocale',
		]),
	},

	methods: {
		saveData({
			token,
			model,
		}) {
			fetch(`${process.env.VUE_APP_BACKEND_API_URL}/u1/data/post/${token}`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json;charset=UTF-8',
				},
				credentials: 'omit',
				mode: 'cors',
				body: JSON.stringify(model),
			}).then((response) => {
				if (!response.ok) {
					throw new Error(response.statusText);
				}

				return response;
			});
		},
		async onSubmit(model) {
			this.isLoading = true;
			let allowLoadingToStop = false;

			// Set minimum load time to 200ms

			setTimeout(() => {
				allowLoadingToStop = true;
				this.isLoading = !(this.showSuccessMessage || this.isError);
			}, MINIMUM_LOAD_TIME);
			try {
				await this.saveData({
					token: this.website.forms[this.data.formId].token,
					model,
				});
				this.showSuccessMessage = true;

				if (!this.data.settings.submitRedirectPage?.pageId) {
					return;
				}

				const { pageId } = this.data.settings.submitRedirectPage;
				const { submitAction } = this.data.settings;

				const pagePath = getPagePathFromId({
					siteData: this.website,
					pageId,
					locale: this.currentLocale,
				});

				if (!pagePath || submitAction.id !== SUBMIT_ACTIONS.LINK_TO_PAGE) {
					return;
				}

				this.$router.push({
					path: pagePath,
				});
			} catch {
				this.isError = true;
			} finally {
				if (allowLoadingToStop) {
					this.isLoading = false;
				}
			}
		},
	},
});
</script>
